import { useState, useEffect } from "react";
import { getNextFormNumber, getDropdownValues, submitForm } from "../api";

const CreateForm = () => {
  const [formNumber, setFormNumber] = useState(""); // Default empty state
  const [name, setName] = useState("");
  const [division, setDivision] = useState("");
  const [occasion, setOccasion] = useState("");
  const [divisions, setDivisions] = useState([]);
  const [occasions, setOccasions] = useState([]);
  const [message, setMessage] = useState("");

  useEffect(() => {
  async function fetchData() {
    try {
      const num = await getNextFormNumber();
      setFormNumber(num); 

      const dropdownData = await getDropdownValues();
      setDivisions(dropdownData.divisions);
      setOccasions(dropdownData.occasions);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
  fetchData();
}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      date: new Date().toLocaleString(),
      name,
      division,
      occasion,
    };
    try {
      const response = await submitForm(formData);
      setMessage(response.message);
    } catch (error) {
      setMessage("Error submitting form. Please try again.");
    }
  };

  return (
    <div className="container">
      <h2>Create New Attendance Form</h2>
      {message && <p>{message}</p>}
      <form onSubmit={handleSubmit}>
        <label>Form Number</label>
        <input type="text" value={formNumber} disabled />

        <label>Name</label>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />

        <label>Division</label>
        <select value={division} onChange={(e) => setDivision(e.target.value)} required>
          <option value="">Select Division</option>
          {divisions.map((div) => (
            <option key={div} value={div}>{div}</option>
          ))}
        </select>

        <label>Occasion</label>
        <select value={occasion} onChange={(e) => setOccasion(e.target.value)} required>
          <option value="">Select Occasion</option>
          {occasions.map((occ) => (
            <option key={occ} value={occ}>{occ}</option>
          ))}
        </select>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default CreateForm;
